<template>
  <div class="center-wrapper">
    <!-- 标题区域 -->
    <slot></slot>
    <div class="chart-container">
      <div class="chart__map" ref="chartMap"></div>
      <div class="chart-wrapper">
        <div class="chart__pie" ref="chartPie"></div>
      </div>
    </div>
  </div>
</template>

<script>
import 'echarts/map/js/china'
import { getAction } from '@/api/manage'
export default {
  name: 'CenterChartPerson',
  data() {
    return {
      mapOption: {
        tooltip: {
          trigger: 'item',
        },
        geo: {
          show: true,
          map: 'china',
          roam: true,
          zoom: 1.2,
          label: {
            emphasis: {
              show: false,
            },
          },
          itemStyle: {
            normal: {
              borderColor: '#027BCE',
              borderWidth: 1,
              areaColor: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: '#026BB5', // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#026BB5', // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
            },
            emphasis: {
              areaColor: '#389BB7',
              borderWidth: 0,
            },
          },
        },
        series: [
          {
            name: 'pm2.5',
            type: 'scatter',
            map: 'china',
            coordinateSystem: 'geo',
            geoIndex: 0,
            data: [],
            // symbolSize: function (val) {
            //   return val[2] / 10;
            // },
            encode: {
              value: 2,
            },
            label: {
              formatter: '{b}',
              position: 'right',
              show: false,
            },
            itemStyle: {
              color: '#A3CA42',
            },
            emphasis: {
              label: {
                show: true,
              },
            },
          },
          {
            name: 'Top 5',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: [],
            encode: {
              value: 2,
            },
            /* symbolSize: function (val) {
              return val[2] / 10;
            }, */
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke',
            },
            hoverAnimation: true,
            label: {
              formatter: '{b}',
              position: 'right',
              show: true,
            },
            itemStyle: {
              color: '#FFFFFF',
              shadowBlur: 10,
              shadowColor: '#333',
            },
            markPoint: {
              symbol: 'pin',
              symbolSize: 65,
              itemStyle: {
                color: '#F1494B',
              },
              label: {
                color: '#ffffff',
              },
              data: [],
            },
          },
        ],
      },
      pieOption: {
        color: ['#0066FF', '#FF9900', '#A3CA42', '#005BDE', '#D2840D', '#619766'],
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        series: [
          {
            name: '类别',
            type: 'pie',
            label: {
              show: true,
              position: 'outside',
            },
            itemStyle: {
              borderColor: '#000',
            },
            data: [],
          },
        ],
      },
      url: {
        mapData: '/show/bigScreen/getMapAndType',
      },
    }
  },
  async mounted() {
    const result = await this.getData()
    const { mapData, prduceTypeData } = result.result
    this.setRenderMapData(mapData, this.mapOption)
    this.setRenderPieData(prduceTypeData, this.pieOption)
    // 初始化图表以及渲染
    const chartMap = this.$echarts.init(this.$refs.chartMap)
    const chartPie = this.$echarts.init(this.$refs.chartPie, 'macarons')
    chartMap.setOption(this.mapOption)
    chartPie.setOption(this.pieOption)
  },
  methods: {
    async getData() {
      return await getAction(this.url.mapData)
    },
    /**
     * @description: 服务数据转化为图标渲染数据
     * @param {list: Array}
     * @return {Array}
     */
    convertData(list) {
      return list.map((item) => {
        const { coord, name, value } = item
        const coordinate = coord
          .slice(1, coord.length - 1)
          .split(',')
          .map((v) => Number(v))
        // 经纬度坐标反了 所有使用reverse方法反转一下
        coordinate.reverse().push(value)
        return {
          name,
          value: coordinate,
        }
      })
    },
    /**
     * @description: 获取排名第五的数据
     * @param {list: Array}
     * @return {Array}
     */
    getTopFiveList(list) {
      return list
        .sort(function (a, b) {
          return b.value[2] - a.value[2]
        })
        .slice(0, 5)
    },
    /**
     * @description: 排名前五备注点数据
     * @param {list: Array}
     * @return {Array}
     */
    getMarkPointList(list) {
      return list.map((point) => {
        const [x, y, value] = point.value
        return {
          name: point.name,
          coord: [x, y],
          value: value,
        }
      })
    },
    /**
     * @description: 设置Map图表渲染数据
     * @param {list: Array, op: Object}
     * @return {undefined}
     */
    setRenderMapData(list, op) {
      const newMapData = this.convertData(list)
      const topFiveList = this.getTopFiveList(newMapData)
      const markPointList = this.getMarkPointList(topFiveList)
      const dataset = new Array(newMapData, topFiveList)
      // 设置渲染数据
      dataset.forEach((data, index) => {
        const seriesItem = op.series[index]
        seriesItem.data = data
        if (seriesItem.markPoint) {
          seriesItem.markPoint.data = markPointList
        }
      })
    },
    /**
     * @description: 设置饼图渲染数据
     * @param {list: Array, op: Object}
     * @return {type}
     */
    setRenderPieData(list, op) {
      op.series[0].data = list
    },
  },
}
</script>

<style lang='less' scoped>
.chart-container {
  display: flex;
  .chart__map,
  .chart__pie {
    width: 500px;
  }
  .chart__map {
    height: 400px;
  }
  .chart__pie {
    height: 400px;
  }
}
.chart-wrapper {
  position: relative;
  .text {
    position: absolute;
    color: #008fee;
    font-size: 24px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
